/**
 * Company logo grid component
 */

interface CompanyLogo {
  name: string;
  logo?: string;
  initials?: string;
}

interface CompanyLogoGridProps {
  companies: CompanyLogo[];
  title?: string;
}

export function CompanyLogoGrid({companies, title}: CompanyLogoGridProps) {
  return (
    <div className="w-full">
      {title && (
        <p className="text-lg text-textSecondary dark:text-[#858585] mb-8 text-center">{title}</p>
      )}
      <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
        {companies.map((company) => (
          <div
            key={company.name}
            className="flex items-center justify-center p-4 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-[#1E1E1E] hover:border-gray-300 dark:hover:border-gray-600 transition-colors"
          >
            {company.logo ? (
              <img src={company.logo} alt={company.name} className="h-8 w-auto opacity-60 hover:opacity-100 transition-opacity" />
            ) : (
              <span className="text-sm font-semibold text-textSecondary dark:text-[#858585]">{company.initials || company.name}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

